<template>
  <b-pagination
    hide-goto-end-buttons
    v-bind="$attrs"
    v-on="$listeners"
    :class="['my-pagination', $attrs.class]"
  />
</template>

<script>
export default {
  name: "my-pagination",
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.my-pagination {
  @apply tw-flex tw-gap-[8px] tw-justify-center tw-items-center tw-my-[16px];

  /* Each page button */
  ::v-deep .page-item {
    @apply tw-w-[32px] tw-h-[32px];
    .page-link {
      @apply tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[var(--my-text-color)] tw-bg-[var(--my-white-soft)] tw-border-none tw-transition-colors tw-duration-150 tw-ease-in-out tw-cursor-pointer;
    }

    /* Active / current page */
    &.active .page-link {
      @apply tw-bg-[var(--my-primary)] tw-text-[var(--my-white)];
    }

    /* Disabled buttons */
    &.disabled .page-link {
      @apply tw-opacity-50 tw-cursor-not-allowed;
    }
  }

  /* Remove focus outline / shadow */
  ::v-deep .page-link:focus {
    @apply tw-outline-none tw-shadow-none;
  }
}
</style>
